import React, {useEffect, useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {TabPanel} from './TabPanel';
import TitleComponent from './TitleComponent';
import '../Notifications.scss';
import {httpRequest} from '../../../httpRequest';
import getUnviewedNotification from './UnviewedNotification';
import {
  ADVISOR_OBJECT_KEY,
  getSessionStorageItem,
  setSessionStorageItem,
  SESSION_STORAGE_NOTIFICATION
} from '../../../sessionStorage';
import useUserInfo from '../../../hooks/useUserInfo';

export default function NotificationTab(props) {
  let sessionStorage = getSessionStorageItem(SESSION_STORAGE_NOTIFICATION);
  const [value, setValue] = useState(sessionStorage ? sessionStorage.currentValue : 0);
  const [isLoading, setIsLoading] = useState(true);
  const {setNotificationCount} = useUserInfo();

  function tabProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    setViewed(0);
  }, []);

  const setViewed = (newValue) => {
    let details = props.notifications[newValue];
    if (!details.viewedByAgent) {
      const baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
      setIsLoading(true);
      httpRequest.put(`${baseAddress}/api/Notification/SetViewed?notificationId=${details.id}`).then((data) => {
        if (data && data.successful) {
          const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
          const notifications = [...props.notifications];
          notifications[newValue].viewedByAgent = true;
          props.setNotifications(notifications);

          getUnviewedNotification().then((count) => {
            advisorObj.unviewedNotificationCount = count;
            setNotificationCount(count);
          }).catch(() => {
            advisorObj.unviewedNotificationCount = 0;
          }).finally(() => {
            setSessionStorageItem(ADVISOR_OBJECT_KEY, advisorObj);
          });
        }
        setIsLoading(false);
      }).catch(() => {
        const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
        if (advisorObj) {
          advisorObj.unviewedNotificationCount = 0;
          setSessionStorageItem(ADVISOR_OBJECT_KEY, advisorObj);
        }
      }).finally(() => {
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }

  const handleChange = (event, newValue) => {
    setViewed(newValue);
    setValue(newValue);
  };

  return (
    <div className="verticalTabs">
      <Tabs
        orientation="vertical"
        variant="standard"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className="tabs"
        TabIndicatorProps={{
          style: {
            display: "none"
          }
        }}
      >
        {props.notifications.map((v, i) =>
          <Tab
            label={<TitleComponent
              title={v.title}
              firstName={v.firstName}
              lastName={v.lastName}
              data={v.body}
              date={v.date}
              viewedByAgent={v.viewedByAgent}
            />}
            key={i}
            {...tabProps(i)}
          />
        )}
      </Tabs>

      {props.notifications.map((v, i) =>
        <TabPanel value={value} isLoading={isLoading} productType={v.productType} firstName={v.firstName}
                  lastName={v.lastName} carrier={v.carrier} faceAmount={v.faceAmount} date={v.date} index={i} key={i}
                  title={v.title} data={v.body} history={props.history} viewedByAgent={v.viewedByAgent}
                  setActiveLink={props.setActiveLink} navlink={props.navLinks}/>
      )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Notifications/SubComponents/NotificationTab.js